export const CUSTOM_DATA_SEGMENT_ACL_OBJECTS = [
    'CustomDataSegmentDetail',
    'CustomDataSegmentCreate',
    'CustomDataSegmentList',
];
